import React, { ReactElement } from 'react';
import { useTranslate } from 'react-translate-plus';

import './ConfirmationDialog.scss';

import { Button, Dialog, Icon, ModalPortal } from '@hoffmann/pattern-library-2';

interface Props {
  isOpen: boolean;
  title: ReactElement | string;
  onConfirm: () => void;
  description: ReactElement | string;
  smallActions?: boolean;
  onCancel?: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
  icon?: any;
  theme?: 'brand' | 'positive' | 'negative' | 'action';
}

const ConfirmationDialog: React.FC<Props> = (props) => {
  const t = useTranslate('ConfirmationDialog');
  const smallActions = props.smallActions || false;
  const cancelLabel = props.cancelLabel || t('BUTTON_CANCEL');
  const confirmLabel = props.confirmLabel || t('BUTTON_CONFIRM');
  const theme = props.theme || 'brand';
  const icon = props.icon && (
    <Icon
      source={props.icon}
      classNames={[`confirmation-dialog__modal-icon--${theme}`, 'confirmation-dialog__modal-icon']}
    />
  );
  return (
    <ModalPortal
      data-cy="modal-portal"
      full
      isOpen={props.isOpen}
      classNames={['confirmation-dialog']}
    >
      <Dialog
        classNames={['confirmation-dialog__modal']}
        title={
          <>
            {icon}
            {props.title}
          </>
        }
        size={100}
        emphasizeActions={!smallActions}
        actions={[
          props.onCancel && (
            <Button key="button1" ghost label={cancelLabel} onClick={props.onCancel} />
          ),
          <Button
            key="button2"
            ghost
            theme={theme}
            label={confirmLabel}
            onClick={props.onConfirm}
          />,
        ]}
      >
        {props.description}
      </Dialog>
    </ModalPortal>
  );
};

export default ConfirmationDialog;
